// ##### 25-02-05 Komarov
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';

// ##### 25-05-21 Komarov
const ButtonComponent = () => {
  // ##### Komarov 2025-08-05
  const ProceedToPayment = useLocalizedText('ProceedToPayment');

  return (
    <button
      data-component="ButtonComponent"
      type="submit"
      style={{
        backgroundColor: '#337ab7',
        color: '#fff',
        borderColor: '#2e6da4',
        border: '1px solid transparent',
        borderRadius: '4px',
        padding: '6px 12px',
        cursor: 'pointer',
      }}
    >
      {
        // ##### 23-10-04 Komarov
        ProceedToPayment
      }
    </button>
  );
};

// ##### 25-05-21 Komarov
export default ButtonComponent;
